var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOneToFiveLevel5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#de332b;}.cls-2{fill:#801617;}.cls-3{fill:none;stroke:#801617;stroke-linecap:round;stroke-miterlimit:10;stroke-width:30px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_5",
    "data-name": 5
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.78,584.5A285,285,0,0,1,99.25,98,285,285,0,1,1,502.3,501,283.17,283.17,0,0,1,300.78,584.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.78,29.5A270.07,270.07,0,0,1,405.86,548.29,270.07,270.07,0,0,1,195.69,50.71,268.12,268.12,0,0,1,300.78,29.5m0-30C135.09-.5.78,133.81.78,299.5s134.31,300,300,300,300-134.31,300-300S466.46-.5,300.78-.5Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 226.78,
    cy: 232.85,
    rx: 25,
    ry: 42.65
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 374.78,
    cy: 232.85,
    rx: 25,
    ry: 42.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M123.44,458a435.38,435.38,0,0,1,355.78,0,190.14,190.14,0,0,0-355.78,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M147.7,193.16c3.22-2,36.31-22.44,63.31-6.08,2.48,1.5,27.49,17.54,23.93,58.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M453.29,193.16c-3.22-2-36.31-22.44-63.31-6.08-2.48,1.5-27.49,17.54-23.93,58.93"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneToFiveLevel5);
export default __webpack_public_path__ + "static/media/one_to_five_level_5.74432c35f342f40b4c2ecdc6c9c22a0d.svg";
export { ForwardRef as ReactComponent };